import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LdapAuthenticationApiService {

  readonly ldapUrl: string = 'configuration/security/ldap';
  readonly ldapTestUrl: string = `${this.ldapUrl}/test`;

  constructor(private http: HttpClient) {}

  public getAuthenticationLDAPConfiguration(): Observable<any> {
    return this.http.get(this.ldapUrl);
  }

  public updateAuthenticationLDAPConfiguration(securitySetting): Observable<any> {
    return this.http.put(this.ldapUrl, securitySetting);
  }

  public testAuthenticationLDAPConfiguration(securitySetting): Observable<any> {
    return this.http.put(this.ldapTestUrl, securitySetting);
  }
}
